<template>
<div>
    <!-- main Contents -->
    <body>
        <div class="preview" v-show="LoadingPage">
        <h1 class="read-only">Dream & Dream 시즌 2 로그인</h1>
            <header>
                <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="19.413" viewBox="0 0 56 19.413">
                    <g data-name="Text/Amway">
                        <path data-name="Red Mark" d="M5.16 88.044s31.054-7.655 54.062-2.261l.072-.25s-20.077-5.948-53.748 1.3z" transform="translate(-4.04 -69.004)" style="fill:#ed174c"/>
                        <path data-name="m = Amway" d="M75.678 26.863v1.267a2.309 2.309 0 0 1 .652-.921 2.591 2.591 0 0 1 1.657-.552 2.8 2.8 0 0 1 .921.162 2.21 2.21 0 0 1 1.353 1.449 2.829 2.829 0 0 1 2.578-1.593 2.721 2.721 0 0 1 1.924.737c.816.8.847 1.666.847 3.841v5h-2.394v-4.44c0-1.5-.031-1.812-.276-2.21a1.053 1.053 0 0 0-.994-.527 1.248 1.248 0 0 0-1.027.543 4.518 4.518 0 0 0-.261 1.994v4.638h-2.395V31.52a3.665 3.665 0 0 0-.243-1.886 1.145 1.145 0 0 0-.98-.552 1.261 1.261 0 0 0-.621.164c-.7.4-.716 1.086-.716 2.861v4.141H73.31v-9.39z" transform="translate(-59.697 -22.739)" style="fill:#00305e"/>
                        <path data-name="w = Amway" d="M148.59 27.78h2.445l-2.445 9.385h-2.235l-1.42-6.342-1.4 6.342h-2.267l-2.448-9.385h2.447l1.287 5.87 1.322-5.87H146l1.306 5.87z" transform="translate(-113.198 -23.657)" style="fill:#00305e"/>
                        <path data-name="a = Amway" d="M207.7 31.319a3.488 3.488 0 0 1-.621 2.283 1.4 1.4 0 0 1-1.044.527 1.492 1.492 0 0 1-1.337-1.1 4.263 4.263 0 0 1-.26-1.611 3.612 3.612 0 0 1 .5-2.066 1.528 1.528 0 0 1 1.191-.691 1.289 1.289 0 0 1 .961.471 3.164 3.164 0 0 1 .61 2.187zm.123 4.8h2.348v-9.4h-2.3v1.213a2.256 2.256 0 0 0-2.086-1.431c-1.6 0-3.683 1.377-3.683 5.073 0 2.935 1.5 4.747 3.5 4.747a2.427 2.427 0 0 0 2.21-1.232z" transform="translate(-164.863 -22.612)" style="fill:#00305e"/>
                        <path data-name="Y = Amway" d="M251.418 27.78h2.436l-2.683 9.312a6.653 6.653 0 0 1-.98 2.248c-.44.47-.961.687-2.9.687-.278 0-.39-.017-.635-.035v-2.085h.635a1.629 1.629 0 0 0 1.011-.236 1.339 1.339 0 0 0 .355-.941 3.053 3.053 0 0 0-.184-.8l-2.6-8.154h2.6l1.534 6.323z" transform="translate(-200.613 -23.686)" style="fill:#00305e"/>
                        <path data-name="A = Amway" d="m19.41 11.924 1.289 4.94h-2.512zM17.887 9.11 13.86 21.931h2.957l.751-2.714h3.775l.77 2.723h2.976L20.894 9.11z" transform="translate(-11.138 -8.363)" style="fill:#00305e"/>
                    </g>
                </svg>
                </div>
            </header>
            <section class="content">
                <div>
                <div>
                    <h2><span>Dream & Dream </span>시즌 <span>2</span></h2>
                    <p>
                    증정품 교환을 위해<br>
                    한국암웨이 회원 확인이 필요합니다.
                    </p>
                    <a @click="goLoginTry">로그인 하러 가기</a>
                </div>
                </div>
            </section>
        </div>
	</body>
</div>
</template>
   
<script>
// Library
import axios from 'axios'
export default {
    metaInfo: {
    title: 'dream-dream 시즌 2',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'dream-dream 시즌 2'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'Dream & Dream 시즌 2'},
        { property:'og:image', content:'../assets/images/bsop/kakao_thumb.jpg'}
    ]
    },
    name: 'couponsCheck',
    data () {
        return {
            aboInfo: {aboNo: '', aboName: ''},
            ready: false,
            LoadingPage: false,
            couponInfo: [],
            couponDetail: [],
            loginTry: false
        }
    },
    methods: {
        init: async function () { // 초기화
            await this.getCouponInformation()
        },
        getCouponInformation: async function(){
			await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/couponsys_getcouponinfo', {
                "coupon_number":this.couponNo
            }).then(response => {
                if (response.status === 200) {
                    console.log('RESULTS ::: ' + JSON.stringify(response.data))
                    this.couponInfo=response.data.info
                    this.couponDetail=response.data.detail

                    if(this.couponInfo.length>0){
                        if(this.couponInfo[0].coupon_id===1){
                            //dream and dream
                            this.LoadingPage=true
                            this.checkLogin()
                        }else if(this.couponInfo[0].coupon_id===2){
                            this.$router.push({name: '/cp/savethetrees', params: {
                            propCouponInfo: this.couponInfo[0],
                            propCouponDetail: this.couponDetail,
                            aboInfo: this.aboInfo,
                            couponNo: this.couponNo
                        }})
                        }else if(this.couponInfo[0].coupon_id===3){
                            this.$router.push({name: '/cp/queenti', params: {
                            propCouponInfo: this.couponInfo[0],
                            propCouponDetail: this.couponDetail,
                            aboInfo: this.aboInfo,
                            couponNo: this.couponNo
                        }})
                        }
                    }
                } else {
                    console.log('response.status : ', response.status)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                }
                }).catch(error => {
                    console.log('error : ', error)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            })
		},

        goLoginTry: function (){
            window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        },
        /**
         * 로그인 체크
         * Hybris OCC  
         **/ 
        checkLogin: async function () {
            await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
            ).then(response => {
                if (response.data.header.status === 'ERROR') { // login fail
                    //window.location.href = process.env.AMWAY_ROOT_URL + '/login'
                } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
                    // login success
                    this.aboInfo.aboNo = atob(response.data.customerUid)
                    this.aboInfo.aboName = response.data.name

                    if(this.aboInfo.aboNo===this.couponInfo[0].abo_number)
                    {
                        this.$router.push({name: '/cp/dreamanddream', params: {
                            propCouponInfo: this.couponInfo[0],
                            propCouponDetail: this.couponDetail,
                            aboInfo: this.aboInfo,
                            couponNo: this.couponNo
                        }})
                    }else{
                        alert('로그인 정보가 다릅니다.')
                    }
                }
            }).catch(ex => {
                alert('로그인이 필요합니다.')
                window.location.href = process.env.AMWAY_ROOT_URL + '/login'
            })
        },

    },
    mounted() {
        window.setTimeout(() => {
            this.ready = true
            this.init()
        }, 10)
    },
    created() {
        this.couponNo = this.$route.params.couponNo
    }
}
</script>

<style>
    @import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/views/couponsys/couponcheck.vue